import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=47ae132b&scoped=true"
import script from "./forgetPwd.vue?vue&type=script&lang=js"
export * from "./forgetPwd.vue?vue&type=script&lang=js"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=47ae132b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae132b",
  null
  
)

export default component.exports